import axios from "axios";
import { Cookies } from "react-cookie";
import { message } from "antd";
import { KeysToCamel, KeysToSnake } from "scripts/helpers";

const _cookies = new Cookies();
const _cookiePath =
	process.env.NODE_ENV === "production"
		? process.env.REACT_APP_COOKIE_PATH
		: window.location.hostname;

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.headers.common["Authorization"] = `Bearer ${
	_cookies.get(process.env.REACT_APP_COOKIE_TOKEN) || ""
}`;
//axios.defaults.headers.common['Access-Control-Allow-Credentials'] = true;
//axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

const delCookie = () => {
	_cookies.remove(process.env.REACT_APP_COOKIE_TOKEN, {
		path: "/",
		domain: _cookiePath,
	});
	axios.defaults.headers.common["Authorization"] = "";
};

const getCookie = () => {
	return _cookies.get(process.env.REACT_APP_COOKIE_TOKEN);
};

const setCookie = (token, expire) => {
	const date = new Date();
	date.setDate(date.getDate() + expire);
	_cookies.set(process.env.REACT_APP_COOKIE_TOKEN, token, {
		path: "/",
		expires: date,
		domain: _cookiePath,
	});
	window.location = "/";
};

const handleError = (response) => {
	if (response.data?.message) message.error(response.data.message);

	switch (response.status) {
		case 400:
			if (response.data?.errors)
				response.data?.errors.forEach((o) => message.error(o.message));
			break;
		case 403:
			break;
		case 404:
			break;
		case 405:
			break;
		case 422:
			break;
		case 500:
			break;
		default:
			window.location = "/auth/login";
			break;
	}
};

const get = (url, params = {}) => {
	return new Promise((resolve, reject) => {
		axios
			.get(url, { params: KeysToSnake(params), validateStatus: false })
			.then((response) => {
				if (response.status === 200) {
					resolve(KeysToCamel(response.data));
				} else {
					handleError(response);
					reject(response.data);
				}
			});
	});
};

const post = (url, params = {}) => {
	return new Promise((resolve, reject) => {
		axios
			.post(url, KeysToSnake(params), { validateStatus: false })
			.then((response) => {
				if (response.status === 200) {
					message.success(response.data.message);
					resolve(KeysToCamel(response.data));
				} else {
					handleError(response);
					reject(response.data);
				}
			});
	});
};

const put = (url, params = {}) => {
	return new Promise((resolve, reject) => {
		axios
			.put(url, KeysToSnake(params), { validateStatus: false })
			.then((response) => {
				if (response.status === 200) {
					message.success(response.data.message);
					resolve(KeysToCamel(response.data));
				} else {
					handleError(response);
					reject(response.data);
				}
			});
	});
};

const del = (url, params = {}) => {
	return new Promise((resolve, reject) => {
		axios
			.delete(url, { params: KeysToSnake(params), validateStatus: false })
			.then((response) => {
				if (response.status === 200) {
					message.success(response.data.message);
					resolve(KeysToCamel(response.data));
				} else {
					handleError(response);
					reject(response.data);
				}
			});
	});
};

const upload = (url, params = {}, progress) => {
	return new Promise((resolve, reject) => {
		axios
			.post(url, params, {
				validateStatus: false,
				headers: { "Content-Type": "multipart/form-data" },
				onUploadProgress: (e) => {
					if (progress) progress(Math.floor((e.loaded / e.total) * 100));
				},
			})
			.then((response) => {
				if (response.status === 200) {
					message.success(response.data.message);
					resolve(KeysToCamel(response.data));
				} else {
					handleError(response);
					reject(response.data);
				}
			});
	});
};

export default {
	cities: (params) => {
		return get("region/cities", params);
	},
	permissions: (params) => {
		return get("panel/permissions", params);
	},
	provinces: (params) => {
		return get("region/provinces", params);
	},

	about: {
		details: () => {
			return get("panel/about-us");
		},
		update: (params) => {
			return put("panel/about-us", params);
		},
	},
	auth: {
		getOtp: (params) => {
			return post("auth/get-otp", params);
		},
		login: (params) => {
			return post("auth/login-password", params);
		},
		loginOtp: () => {
			return post("auth/login-otp");
		},
		logout: () => {
			return get("auth/logout");
		},
		me: () => {
			return get("auth/me");
		},
		passReset: (params) => {
			return post("auth/pass-reset", params);
		},
	},
	banner: {
		create: (params) => {
			return post("panel/banners", params);
		},
		delete: (id) => {
			return del(`panel/banners/${id}`);
		},
		list: (params) => {
			return get("panel/banners", params);
		},
		update: (id, params) => {
			return put(`panel/banners/${id}`, params);
		},
		status: (id) => {
			return get(`panel/banners/${id}/status`);
		},
	},
	category: {
		create: (params) => {
			return post("panel/categories", params);
		},
		delete: (id) => {
			return del(`panel/categories/${id}`);
		},
		list: (params) => {
			return get("panel/categories", params);
		},
		update: (id, params) => {
			return put(`panel/categories/${id}`, params);
		},
		status: (id, params) => {
			return get(`panel/categories/${id}/status`, params);
		},
	},
	contact: {
		details: () => {
			return get("panel/contact-us");
		},
		update: (params) => {
			return put("panel/contact-us", params);
		},
	},
	faq: {
		create: (params) => {
			return post("panel/faqs", params);
		},
		delete: (id) => {
			return del(`panel/faqs/${id}`);
		},
		list: (params) => {
			return get("panel/faqs", params);
		},
		update: (id, params) => {
			return put(`panel/faqs/${id}`, params);
		},
	},
	job: {
		subscribe: (jobId, subscriptionId) => {
			return put(`panel/jobs/${jobId}/attach-subscription/${subscriptionId}`);
		},
		create: (params) => {
			return post("panel/jobs", params);
		},
		delete: (id) => {
			return del(`panel/jobs/${id}`);
		},
		details: (id) => {
			return get(`panel/jobs/${id}`);
		},
		ladder: (id, params) => {
			return put(`panel/jobs/${id}/active-ladder`, params);
		},
		list: (params) => {
			return get("panel/jobs", params);
		},
		status: (id, params) => {
			return put(`panel/jobs/${id}/status`, params);
		},
		update: (id, params) => {
			return put(`panel/jobs/${id}`, params);
		},
	},
	notifications: {
		create: (params) => {
			return post("panel/notifications", params);
		},
		delete: (id) => {
			return del(`panel/notifications/${id}`);
		},
		details: (id) => {
			return get(`panel/notifications/${id}`);
		},
		list: (params) => {
			return get("panel/notifications", params);
		},
		status: (id) => {
			return get(`panel/notifications/${id}/status`);
		},
		update: (id, params) => {
			return put(`panel/notifications/${id}`, params);
		},
	},
	paymentVerification: {
		details: (id) => {
			return get(`panel/payment-confirmations/${id}`);
		},
		list: (params) => {
			return get("panel/payment-confirmations", params);
		},
		status: (id, params) => {
			return put(`panel/payment-confirmations/${id}/status`, params);
		},
	},
	platform: {
		create: (params) => {
			return post("panel/platforms", params);
		},
		details: (id) => {
			return get(`panel/platforms/${id}`);
		},
		delete: (id) => {
			return del(`panel/platforms/${id}`);
		},
		list: (params) => {
			return get("panel/platforms", params);
		},
		status: (id) => {
			return get(`panel/platforms/${id}/status`);
		},
		update: (id, params) => {
			return put(`panel/platforms/${id}`, params);
		},
	},
	report: {
		list: (params) => {
			return get("panel/reports", params);
		},
		details: (id) => {
			return get(`panel/reports/${id}`);
		},
	},
	role: {
		create: (params) => {
			return post("panel/roles", params);
		},
		delete: (id) => {
			return del(`panel/roles/${id}`);
		},
		details: (id) => {
			return get(`panel/roles/${id}`);
		},
		list: (params) => {
			return get("panel/roles", params);
		},
		update: (id, params) => {
			return put(`panel/roles/${id}`, params);
		},
	},
	settings: {
		details: () => {
			return get("panel/settings");
		},
		update: (params) => {
			return put("panel/settings", params);
		},
	},
	specialJob: {
		create: (params) => {
			return post("panel/special-jobs", params);
		},
		delete: (id) => {
			return del(`panel/special-jobs/${id}`);
		},
		details: (id) => {
			return get(`panel/special-jobs/${id}`);
		},
		list: (params) => {
			return get("panel/special-jobs", params);
		},
		update: (id, params) => {
			return put(`panel/special-jobs/${id}`, params);
		},
	},
	subscription: {
		create: (params) => {
			return post("panel/subscriptions", params);
		},
		delete: (id) => {
			return del(`panel/subscriptions/${id}`);
		},
		list: (params) => {
			return get("panel/subscriptions", params);
		},
		update: (id, params) => {
			return put(`panel/subscriptions/${id}`, params);
		},
		status: (id) => {
			return get(`panel/subscriptions/${id}/status`);
		},
	},
	support: {
		list: (params) => {
			return get("panel/support-messages", params);
		},
		details: (id) => {
			return get(`panel/support-messages/${id}`);
		},
	},
	tac: {
		details: () => {
			return get("panel/tac");
		},
		update: (params) => {
			return put("panel/tac", params);
		},
	},
	tracker: {
		list: (params) => {
			return get("panel/tracker-reports", params);
		},
		details: (id) => {
			return get(`panel/tracker-reports/${id}`);
		},
	},
	transactions: {
		list: (params) => {
			return get("panel/transactions", params);
		},
		details: (id) => {
			return get(`panel/transactions/${id}`);
		},
	},
	user: {
		create: (params) => {
			return post("panel/users", params);
		},
		delete: (id) => {
			return del(`panel/users/${id}`);
		},
		list: (params) => {
			return get("panel/users", params);
		},
		update: (id, params) => {
			return put(`panel/users/${id}`, params);
		},
		roles: (id, params) => {
			return put(`panel/users/${id}/change-role`, params);
		},
		status: (id) => {
			return get(`panel/users/${id}/status`);
		},
	},
	version: {
		create: (params) => {
			return post("panel/versions", params);
		},
		details: (id) => {
			return get(`panel/versions/${id}`);
		},
		delete: (id) => {
			return del(`panel/versions/${id}`);
		},
		list: (params) => {
			return get("panel/versions", params);
		},
		update: (id, params) => {
			return put(`panel/versions/${id}`, params);
		},
	},
	upload,
	delCookie,
	getCookie,
	setCookie,
	delCookie,
};
